export default class FileUploadError extends Error {
  constructor(filePath, status, statusText) {
    super(`file upload error ${status} ${statusText} ${filePath}`);
    this.name = 'FileUploadError'; // (2)
  }
}
